import Map from 'ol/Map';
import React from 'react';
import { fromLonLat } from 'ol/proj';
import View from 'ol/View';
import { defaults as defaultControls } from 'ol/control';
import { MapAdapter } from '../map/mapAdapter';

const defaultAdapter = new MapAdapter({ type: 'googleMaps' } as any);

export const MapContext = React.createContext<Map>(
  new Map({
    layers: [defaultAdapter.baseLayer],
    view: new View({
      center: fromLonLat([0, 0]),
      zoom: 7,
      extent: [-20026376.39, -20048966.1, 20026376.39, 20048966.1],
      constrainOnlyCenter: false,
      constrainResolution: true,
      smoothExtentConstraint: true
    }),
    controls: defaultControls()
  })
);